"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_dom_1 = tslib_1.__importDefault(require("react-dom"));

var react_id_generator_1 = tslib_1.__importDefault(require("react-id-generator"));

var ToastContainer_1 = tslib_1.__importDefault(require("./ToastContainer"));
/**
 *
 * @param message string
 * @param options ToastPropsType
 * @descriptions
 * Toast는 createPortal을 이용해서 body의 하위 자식으로 추가되므로 실제로는 "#mrt-toast-root" div의 자식으로 추가되지 않습니다.
 * @example
 *
 * createToast('Hello Toast!');
 * createToast('Hello Toast!', {
 *   color: 'success',
 *   position: 'bottom',
 * });
 */


function createToast(message, options) {
  var existMrtToastRootEl = document.getElementById('mrt-toast-root');
  var mrtToastRootEl = existMrtToastRootEl;

  if (!mrtToastRootEl) {
    mrtToastRootEl = document.createElement('div');
    mrtToastRootEl.id = 'mrt-toast-root';
    document.body.appendChild(mrtToastRootEl);
  }

  var newToastOption = Object.assign({
    id: react_id_generator_1.default(),
    children: message
  }, options);
  react_dom_1.default.render(jsx_runtime_1.jsx(ToastContainer_1.default, {
    newToastOption: newToastOption
  }, void 0), mrtToastRootEl);
}

exports.default = createToast;